import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'hotjar_config-hotjar_setting_config_limit_exceeded-error';

/**
 * This event is to track if too many settings are being serialized to the Hotjar config.
 */
export function trackHotjarConfigHotjarSettingConfigLimitExceededError(
  Application_string: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { Application_string },
  });
}
